import React from 'react';
import { cacheFunc } from '../../common/services/builders';
import PropTypes from 'prop-types';


function TWICLCertificationsListingCard({ entry, settings }) {
    return (
        <div className="column large-3">
        <a href={cacheFunc.getCachedUrl(entry)}>
            <article className="ui-card cswip" style={{minHeight: 460 + 'px'}}>
                <div className="ui-card__image">
                    <div className="ui-card__image-container" style={renderImage(entry)}></div>
                </div>
                    {<div className="ui-card__type">{entry.schemeName}</div>}
                    {renderCardContent(entry)}
            </article> 
            </a>
        </div>   
        )  
}

function renderImage(entry){
    let styles = {};
    if(entry.heroImage != null && entry.heroImage != ''){
        styles = {backgroundImage: `url(${entry.heroImage.asset.sys.uri})`};
    }
    else{
        styles = {backgroundImage: `url(/site-elements/images/hero/hero-slider-1.jpg)`};
    }
    return styles;
}


function renderCardContent(entry){
    switch (entry.sys.contentTypeId){
        case 'cswipSchemes':
            return <div className="ui-card__content">
                <p className="ui-card__text">{getThumbDescription(entry)}</p>
            </div>;
        }
}


export function getThumbDescription(entry){
	let thumbDescriptionText;
	
	if(entry && entry.thumbnailDescription){
		thumbDescriptionText = entry.thumbnailDescription;
	}
	return thumbDescriptionText;
}

TWICLCertificationsListingCard.propTypes = {
    search: PropTypes.object,
    settings: PropTypes.object,
    filters: PropTypes.object,
    entries: PropTypes.object,
	options: PropTypes.object,
	title: PropTypes.string
};


export default TWICLCertificationsListingCard;